<template>
  <div
    class="projects-wrapper"
    :class="{ 'projects-wrapper-side-panel': this.$route.name !== 'companies' }"
  >
    <div
      class="projects"
      :class="{ 'projects-mobile-hidden': this.$route.name !== 'companies' }"
    >
      <div class="projects-header">
        <h2 class="desktop">{{ $t("companies") }}</h2>
        <!-- ACTIVE/INACTIVE SWITCH -->
        <div class="switch-wrapper" v-if="this.$route.name === 'companies'">
          <label
            class="switch-label"
            :class="{ 'switch-label-active': !showActiveProjects }"
            @click="showActiveProjects = false"
            >{{ $t("inactive") }}</label
          >
          <div class="switch-container">
            <label class="switch">
              <input type="checkbox" v-model="showActiveProjects" />
              <span class="slider"></span>
            </label>
          </div>
          <label
            class="switch-label"
            :class="{ 'switch-label-active': showActiveProjects }"
            @click="showActiveProjects = true"
            >{{ $t("active") }}</label
          >
        </div>
        <!-- NEW USER BUTTON DESKTOP-->
        <button
          class="btn btn-new desktop"
          @click="newCompany()"
          v-if="this.$route.name === 'companies'"
        >
          <span class="tms">a</span>
          {{ $t("new-company") }}
        </button>
      </div>
      <div
        class="companies-container"
        :class="{ 'no-overflow': this.$route.name === 'companies' }"
      >
        <ul class="companies-ul-wrapper">
          <!-- КОМПАНИИ -->
          <li
            v-for="c in companies"
            :key="c._id"
            :class="{ 'company-li-inactive': !showActiveProjects }"
            class="company-li"
            :ref="c._id"
          >
            <div
              class="company-toggle"
              :class="{ 'company-toggle-inactive': !showActiveProjects }"
              @click="toggleElements(c._id, 'company', 'project')"
            >
              <span class="tms">M</span>
              <span>
                <strong>{{ c.companyName }}</strong>
              </span>
            </div>
            <!-- ОБЕКТИ -->
            <ul class="projects-ul-wrapper">
              <li
                v-for="o in c.objects"
                :key="o._id"
                class="project-li"
                :ref="o._id"
              >
                <div
                  class="project-toggle"
                  @click="
                    toggleElements(o._id, 'project', 'object'),
                      newPart(c._id, o._id, o.parts[0]._id)
                  "
                >
                  <span class="tms">M</span>
                  <span>
                    <strong>{{ $t("site").toUpperCase() }}:</strong>
                    {{ o.objectName }}
                  </span>
                </div>
                <!-- ЧАСТ -->
                <ul class="objects-ul-wrapper" v-if="o.parts.length">
                  <li
                    v-for="p in o.parts"
                    :key="p._id"
                    class="object-li"
                    :ref="p._id"
                  >
                    <div
                      class="object-toggle"
                      @click="
                        toggleElements(p._id, 'object', 'part'),
                          newPart(c._id, o._id, p._id)
                      "
                    >
                      <!-- <span class="tms">M</span> -->
                      <span
                        :class="{ 'object-selected': selectedObject === o._id }"
                      >
                        <strong>{{ $t("part").toUpperCase() }}:</strong>
                        {{ p.partName }}
                      </span>
                    </div>
                    <!-- ЧАСТ -->
                    <!-- <ul class="objects-ul-wrapper" v-if="p.parts.length">
                      <li v-for="part in o.parts" :key="part._id" class="part-li" :ref="part._id">
                        <div class="part-toggle" @click="getPart(c._id, p._id, o._id, part._id)">
                          <span class="tms">M</span>
                          <span>
                            <strong>{{ $t('part').toUpperCase() }}:</strong>
                            {{part.partName}}
                          </span>
                        </div>
                      </li>
                      <li class="part-toggle new-btn-mini-toggle">
                        <span class="tms">M</span>
                        <a class="new-btn-mini" @click="newPart(c._id, p._id, o._id)">
                          <span class="tms">L</span>
                          {{ $t('create-new-part') }}
                        </a>
                      </li>
                    </ul> -->
                  </li>
                  <li class="object-toggle new-btn-mini-toggle">
                    <span class="tms">M</span>
                    <a class="new-btn-mini" @click="newPart(c._id, o._id)">
                      <span class="tms">L</span>
                      {{ $t("create-new-part") }}
                    </a>
                  </li>
                </ul>
              </li>
              <li class="project-toggle new-btn-mini-toggle">
                <span class="tms">M</span>
                <a class="new-btn-mini" @click="newObject(c._id)">
                  <span class="tms">L</span>
                  {{ $t("create-new-site") }}
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
      <!-- BUTTON NEW COMPANY FOR MOBILE -->
      <footer class="modal-footer mobile">
        <div
          class="new-content-data-item-toggle-circle mobile"
          v-if="this.$route.name === 'companies'"
          @click="newCompany()"
        >
          <span class="tms">L</span>
        </div>
      </footer>
    </div>
    <!-- COMPANY DETAILS SLIDE -->
    <transition name="slideFromRight">
      <Company
        :showActive="showActiveProjects"
        v-if="
          this.$route.name === 'newObject' ||
          this.$route.name === 'newPart' ||
          this.$route.name === 'getPart'
        "
      />
    </transition>
  </div>
</template>

<script>
import Company from "./Company";
export default {
  components: {
    Company: Company,
  },
  watch: {
    "$route.name"(to) {
      if (to === "companies") {
        this.getCompanies();
      }
    },
    "$route.query"() {
      if (this.$route.query.removed) this.getCompanies();
    },
    showActiveProjects() {
      this.getCompanies();
    },
  },
  data() {
    return {
      selectedObject: "",
      showActiveProjects: true,
      companies: [],
      search: "",
    };
  },
  methods: {
    getCompanies() {
      this.$store.dispatch("startLoading");
      this.companies = [];
      let type = this.showActiveProjects ? "active" : "inactive";
      let requestUrl = `${process.env.VUE_APP_BASE_URI}/company/${type}`;
      // let requestUrl = `${process.env.VUE_APP_BASE_URI}/company`;
      if (this.search.length) {
        // requestUrl += `/${this.search}`;
        requestUrl += `?search=${this.search}`;
      }
      this.$http.get(requestUrl).then((response) => {
        this.companies = response.data;
        this.$store.dispatch("stopLoading");
      });
    },
    // Filter Companies by companyName
    searchFilter() {
      return this.companies.filter((c) => {
        return c.companyName.toLowerCase().includes(this.search.toLowerCase());
      });
    },
    toggleElements(id, parent, child) {
      const parentElement = this.$refs[id][0];
      const selectedChildren = parentElement.getElementsByClassName(
        `${child}-toggle`
      );
      if (selectedChildren) {
        // Close
        if (parentElement.classList.contains(`${parent}-li-active`)) {
          for (let i = 0; i < selectedChildren.length; i++) {
            selectedChildren[i].classList.remove(`${child}-toggle-active`);
          }
          parentElement.classList.remove(`${parent}-li-active`);
          // Close children also
          this.closeEverythingInside(id, parent);
        } else {
          // Open
          for (let i = 0; i < selectedChildren.length; i++) {
            selectedChildren[i].classList.add(`${child}-toggle-active`);
          }
          parentElement.classList.add(`${parent}-li-active`);
        }
      }
    },
    closeEverythingInside(id, parent) {
      const element = this.$refs[id][0];
      const types = ["project", "object", "part"];
      for (let i = types.length; i > types.indexOf(parent); i--) {
        const activeToggleItems = element.getElementsByClassName(
          `${types[i]}-toggle-active`
        );
        const activeLiItems = element.getElementsByClassName(
          `${types[i]}-li-active`
        );
        while (activeLiItems.length > 0) {
          activeLiItems[0].classList.remove(`${types[i]}-li-active`);
        }
        while (activeToggleItems.length > 0) {
          activeToggleItems[0].classList.remove(`${types[i]}-toggle-active`);
        }
      }
    },
    // METHODS FOR ROUTING
    newCompany() {
      this.selectedPart = "";
      this.$router.push("/companies/new");
    },
    newObject(companyId) {
      this.selectedPart = "";
      this.$router.push(`/companies/${companyId}`);
    },
    newPart(companyId, objectId, partId) {
      this.selectedPart = "";
      if (partId)
        this.$router.push(`/companies/${companyId}/${objectId}/${partId}`);
      else this.$router.push(`/companies/${companyId}/${objectId}`);
    },
    // newPart(companyId, projectId, objectId) {
    //   this.selectedPart = objectId;
    //   this.$router.push(`/companies/${companyId}/${projectId}/${objectId}`);
    // },
    getPart(companyId, projectId, objectId, partId) {
      this.selectedPart = objectId;
      this.$router.push(
        `/companies/${companyId}/${projectId}/${objectId}/${partId}`
      );
    },
  },
  mounted() {
    this.getCompanies();
    // Handle search input
    this.$root.$on("sendSearchInput", (data) => {
      this.search = data;
      this.getCompanies();
    });
  },
  destroyed() {
    this.$root.$off("sendSearchInput");
  },
};
</script>

<style scoped>
.projects-wrapper {
  display: flex;
}
.projects {
  padding: 10px 40px;
  width: 100%;
  transition: all 0.3s;
}
.projects-wrapper-side-panel .projects {
  padding-right: 0;
  width: 30%;
}
.projects-header {
  align-items: center;
  display: flex;
  height: 36px;
  justify-content: space-between;
}
.companies-container {
  overflow: auto;
  max-height: 100vh;
}
.no-overflow {
  overflow: unset;
  max-height: none;
}
.switch-wrapper {
  align-items: center;
  display: flex;
}
.switch {
  margin: 0 10px;
}
.switch-label {
  cursor: pointer;
  font-weight: 700;
  opacity: 0.4;
}
.switch-label-active {
  opacity: 1;
}
/* COMPANY */
.company-li {
  background-color: #104d8033;
  border: 1px solid #cecece;
  border-radius: 4px;
  display: block;
  margin-top: 10px;
  overflow: hidden;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
}
.company-li-inactive {
  background-color: #fff8f8;
}
.company-li-active {
  padding-bottom: 15px;
}
.company-toggle {
  align-items: center;
  background-color: #104d8033;
  cursor: pointer;
  display: flex;
  height: 50px;
  padding: 0 10px;
  -webkit-transition: background-color 0.3s;
  -moz-transition: background-color 0.3s;
  -ms-transition: background-color 0.3s;
  -o-transition: background-color 0.3s;
  transition: background-color 0.3s;
}
.company-toggle-inactive {
  background-color: #fff8f8;
}
.company-toggle:hover {
  color: rgba(0, 0, 0, 0.8);
}
.company-toggle > .tms {
  margin: 0 7px 0 4px;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
}
/* PROJECTS */
.projects-ul-wrapper,
.objects-ul-wrapper,
.part-ul-wrapper {
  padding-left: 34px;
}
.project-toggle,
.object-toggle,
.part-toggle,
.new-btn-mini-toggle {
  align-items: center;
  cursor: pointer;
  display: flex;
  height: 0;
  overflow: hidden;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
}
.project-toggle:hover,
.object-toggle:hover,
.part-toggle:hover {
  color: rgba(0, 0, 0, 0.8);
}
.project-toggle-active,
.object-toggle-active,
.part-toggle-active,
.new-btn-mini-toggle-active {
  height: 25px;
}
.project-toggle > .tms,
.object-toggle > .tms,
.part-toggle > .tms {
  margin-right: 7px;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
}
.company-li-active .company-toggle .tms,
.project-li-active .project-toggle .tms,
.object-li-active .object-toggle > .tms,
.part-li-active .part-toggle > .tms {
  transform: rotate(90deg);
}
/* FIX TEXTS OVERFLOW */
.company-li span:nth-child(2),
.project-li span:nth-child(2),
.object-li span:nth-child(2),
.part-li span:nth-child(2) {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
/* NEW MINI BTN */
.new-btn-mini-toggle > .tms {
  color: #0058bc;
}
.new-btn-mini {
  align-items: center;
  background-color: #0058bc;
  border-radius: 10px;
  color: #fff;
  cursor: pointer;
  font-size: 12px;
  display: inline-flex;
  padding: 3px 10px;
  -webkit-transition: background-color 0.3s;
  -moz-transition: background-color 0.3s;
  -ms-transition: background-color 0.3s;
  -o-transition: background-color 0.3s;
  transition: background-color 0.3s;
}
.new-btn-mini > .tms {
  margin-right: 7px;
  font-size: 10px;
}
.new-btn-mini:hover {
  background-color: rgb(23, 112, 214);
}
.object-selected {
  /* color: #8d3506; */
  color: #0058bc;
}
.desktop {
  display: flex;
}
.mobile {
  display: none;
}
@media screen and (max-width: 1000px) {
  .desktop,
  .projects-mobile-hidden {
    display: none;
  }
  .mobile {
    display: flex;
  }
  .projects {
    padding: 10px 15px;
    width: 100%;
  }
  .projects-header {
    justify-content: center;
    width: 100%;
  }
  .projects-wrapper.projects-wrapper-side-panel {
    justify-content: center;
  }
  .company-toggle {
    height: 65px;
    width: 100%;
  }
  .project-toggle-active,
  .object-toggle-active,
  .part-toggle-active,
  .new-btn-mini-toggle-active {
    height: 40px;
    width: 100%;
  }
  .new-content-data-item-toggle-circle {
    font-size: 20px;
    height: 50px;
    width: 50px;
  }
  .new-content-data-item-toggle-circle.mobile {
    bottom: 20px;
    cursor: pointer;
    position: fixed;
    right: 20px;
  }
  .modal-footer {
    background-color: #fff;
    height: 75px;
    padding: 0px;
  }
}
</style>
